import { render, staticRenderFns } from "./ConsultantInvitationFlow.vue?vue&type=template&id=7448f429&"
import script from "./ConsultantInvitationFlow.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ConsultantInvitationFlow.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports